var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid gap-10 place-items-center p-12 lg:px-20 w-full leading-relaxed",attrs:{"id":"app"}},[_c('Header'),_c('main',{staticClass:"w-full max-w-5xl relative"},[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }